import {Button, Card, Dropdown, Space, Table} from "antd";
import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {t} from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";
import Helper from "../../core/Helper";
import {TemplateLanguages} from "../../enums/TemplateLanguages";
import { FilterActions, SearchCard } from "../../core/components/quick-filter/QuickFilterParts";
import { matchesSearch } from "../../core/utils/text-search";
import AppLink from "../../core/components/AppLink";

export default function UnitList()
{
    const history = useHistory();
    const [units, setUnits] = useState([]);
    const [search, setSearch] = useState('')

    const getUnits = async () => {
        const res = await ApiService.Unit.GetUnitList();

        if(res.success)
        {
            setUnits(res.data);
        }
    }

    const deleteUnit = async (unitId) => {
        const res = await ApiService.Unit.DeleteUnit(unitId);
        if(res.success)
        {
            await getUnits();
        }
    }

    useEffect(() => {
        getUnits()
    }, [])

    // Word yükleme v1 hattıdır: yüklenen dosya o dil için geçerli çıktı kaynağı olur ve şablon
    // engine_version = 1'e döner. Builder'da düzenlemek için "Şablonlar" bağlantısı kullanılır.
    const upload = async (unitId, language) => {
        const resFile = await Helper.File.getFileAsBase64({accept: '*.docx'});
        if(resFile?.data)
        {
            await ApiService.Unit.UploadDefaultForm(unitId, {
                fileBase64: resFile.data,
                language
            });
            await getUnits();
        }
    }

    const filteredData = search ? units.filter(x => matchesSearch(x.name, search)) : units

    const renderAction = (row) => {
        return (
            <Space>
                <AppLink key="edit" to={`/app/system/units/edit/${row.id}`}>{t('Edit')}</AppLink>
                |
                <a key="form-templates" onClick={() => history.push(`/app/system/unit-form-templates/${row.id}`)}>
                    {t('Onam Formu Şablonları')}
                </a>
                |
                <Dropdown
                    key="form-upload"
                    trigger={['click']}
                    menu={{
                        items: TemplateLanguages.map(code => ({ key: code, label: t(`lang_${code}`) })),
                        onClick: async ({ key }) => { await upload(row.id, key) }
                    }}
                >
                    <a onClick={(e) => e.preventDefault()}>{t('Upload Onam Form')}</a>
                </Dropdown>
                |
                <a key="delete" onClick={async () => {await deleteUnit(row.id)}} style={{color: 'red'}}>{t('Delete')}</a>
            </Space>
        )
    }

    return (
        <SimpleLayout fullWidth={true}>
            <div className="qf-row qf-row-top">
                <SearchCard value={search} onChange={setSearch} />
            </div>
            <FilterActions>
                <Button size={'small'} onClick={() => {history.push(`/app/system/units/create`)}} type={'primary'}>{t('New')}</Button>
                <Button size={'small'} onClick={getUnits}>{t('Refresh')}</Button>
            </FilterActions>
            <Card>
                <Table
                    size={'small'}
                    dataSource={filteredData}
                    pagination={false}
                    rowKey={'id'}
                    columns={[
                        {key: 'name', dataIndex: 'name', title: t('Name')},
                        {key: 'firm', dataIndex: 'firm', title: t('Firm'), render: (text, row) => row?.firm?.name},
                        {key: '#', dataIndex: '#', title: '#', render: (text, row) => renderAction(row)},
                    ]}
                />
            </Card>
        </SimpleLayout>
    )
}
